<div class="brand-background text-white">
  <h1 class="text-center pt-5"><strong translate>app.home.title</strong></h1>

  <h2 class="text-center">
    Manage your crypto assets by <strong>Crypto Monitor</strong> from sdv291
  </h2>

  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="d-none d-lg-inline col-lg-6">
        <img class="img-fluid" src="/assets/img/deals_block.png" alt="deals example image"/>
      </div>
      <div class="col-lg-4 col-md-12">
        <p class="h3">
          Track the status of your assets from different Exchanges and Wallets in one service!
        </p>
        <strong class="h2">It has never been so easy before!</strong>
        <br/>
        <br/>
        <p class="h4">Telegram channel <a class="link-light" href="https://t.me/channel_sdv291" >sdv291</a></p>
        <br/>
        <button type="button" routerLink="/dashboard" *ngIf="apiService.isAuthorized()"
                class="btn btn-lg btn-light" translate>app.buttons.try.now</button>
        <button type="button" routerLink="/sign-in" *ngIf="apiService.isAnonymous()"
                class="btn btn-lg btn-light" translate>app.buttons.try.now</button>
        <button type="button" class="btn btn-lg btn-success mx-1" (click)="userService.auth({
      contact: 'guest@sdv291.com',
      password: 'guest'
    })" *ngIf="apiService.isAnonymous()" translate>app.buttons.demo
        </button>
      </div>
    </div>
  </div>
</div>
